import { render, staticRenderFns } from "./activityRule.vue?vue&type=template&id=a47c560a&scoped=true"
import script from "./activityRule.vue?vue&type=script&lang=js"
export * from "./activityRule.vue?vue&type=script&lang=js"
import style0 from "./activityRule.vue?vue&type=style&index=0&id=a47c560a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47c560a",
  null
  
)

export default component.exports